import { render, staticRenderFns } from "./ui-label.vue?vue&type=template&id=e9447ec0&scoped=true"
import script from "./ui-label.vue?vue&type=script&lang=js"
export * from "./ui-label.vue?vue&type=script&lang=js"
import style0 from "./ui-label.vue?vue&type=style&index=0&id=e9447ec0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9447ec0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e9447ec0')) {
      api.createRecord('e9447ec0', component.options)
    } else {
      api.reload('e9447ec0', component.options)
    }
    module.hot.accept("./ui-label.vue?vue&type=template&id=e9447ec0&scoped=true", function () {
      api.rerender('e9447ec0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/ui/forms/label/ui-label.vue"
export default component.exports